import React, { useState } from "react";
import { Dialog } from "@headlessui/react";
import { fetchAuth } from "../../../../shared/common/api";
import { useTheme } from "../../../../shared/common/ThemeContext";

const gpsProviders = [
    "Catapult",
    "StatSports",
    "Ksport",
    "Wimu Pro",
    "Apex / PlayerTek",
    "Polar Team Pro",
    "Fitogether",
    "FieldWiz",
    "Gpexe",
    "VX Sport",
    "ZXY",
    "BePro",
    "Other"
  ];

const UpdateTrackingTokenModal = ({ isOpen, onClose}) => {
  const [tokenAPI, setTokenAPI] = useState("");
  const [provider, setProvider] = useState(gpsProviders[0]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const { isDarkMode } = useTheme(); // 👈 Contexte thème

  const handleSubmit = async () => {
    if (!tokenAPI || !provider) return;

    setLoading(true);
    setMessage("");

    try {
      const response = await fetchAuth(`/clubs/update_gps_token`, {
        method: "POST",
        body: JSON.stringify({ tokenAPI, provider }),
      });

      const result = await response.json();

      if (!response.ok) throw new Error(result.error || "Update failed");

      setMessage("✅ Token updated successfully.");
      setTimeout(onClose, 1000);
    } catch (err) {
      setMessage(`❌ ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose} className="fixed z-50 inset-0 flex items-center justify-center">
      <Dialog.Panel
        className={`p-6 rounded-lg shadow-xl w-full max-w-md space-y-4 transition-all ${
          isDarkMode
            ? "bg-gray-900 text-white border border-gray-700"
            : "bg-white text-gray-800 border border-gray-300"
        }`}
      >
        <Dialog.Title className="text-lg font-semibold">Update GPS Tracking Token</Dialog.Title>

        <div>
          <label className="block mb-1 text-sm font-medium">GPS Provider</label>
          <select
            value={provider}
            onChange={(e) => setProvider(e.target.value)}
            className={`w-full p-2 rounded border ${
              isDarkMode ? "bg-gray-800 text-white border-gray-600" : "bg-white text-black"
            }`}
          >
            {gpsProviders.map((p) => (
              <option key={p} value={p}>{p}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="block mb-1 text-sm font-medium">API Token</label>
          <input
            type="text"
            value={tokenAPI}
            onChange={(e) => setTokenAPI(e.target.value)}
            className={`w-full p-2 rounded border ${
              isDarkMode ? "bg-gray-800 text-white border-gray-600" : "bg-white text-black"
            }`}
          />
        </div>

        {message && <p className="text-sm">{message}</p>}

        <div className="flex justify-end space-x-2">
          <button
            onClick={onClose}
            className={`px-4 py-2 rounded ${
              isDarkMode ? "bg-gray-600 text-white" : "bg-gray-400 text-white"
            }`}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className={`px-4 py-2 rounded ${
              isDarkMode ? "bg-indigo-600 hover:bg-indigo-700" : "bg-blue-600 hover:bg-blue-700"
            } text-white disabled:opacity-50`}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save"}
          </button>
        </div>
      </Dialog.Panel>
    </Dialog>
  );
};

export default UpdateTrackingTokenModal;
